import { ethers } from "ethers";
import { getWeb3 } from "./connectors";
import { DEFAULT_CHAIN } from "./constant";


export const getContract = (abi, address, library) => {
  try{
    return new ethers.Contract(address, abi, library.getSigner())
  }
  catch{
    return false;
  }
}


export const formatPrice = (num) => {
  //return parseFloat(num.toFixed(decimals)).toLocaleString();
  return new Intl.NumberFormat('ja-JP').format(parseFloat(num).toFixed(3));
}


export const getWeb3Contract = (abi, address) => {
  let web3 = getWeb3(DEFAULT_CHAIN);
  return new web3.eth.Contract(abi, address);
}


